import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import API, { fmt, PAYMENT_TYPES, ORDER_STATUS } from '../utils/api';
import FinishedProductPicker from '../components/FinishedProductPicker';
import Pagination from '../components/Pagination';

const EMPTY_FORM = {
  customer_id:'', payment_type:'cash', discount:0,
  due_date:'', notes:'',
  items:[{ finished_product_id:'', flavor_id:'', product_name:'', quantity:1, unit_price:0 }]
};
const EMPTY_PAY = {
  amount:0, payment_type:'cash', check_number:'',
  payment_date: new Date().toISOString().split('T')[0], notes:''
};

const STATUS_BADGE  = { pending:'badge-warning', confirmed:'badge-primary', delivered:'badge-success', cancelled:'badge-danger' };
const STATUS_LABEL  = { pending:'معلق', confirmed:'مؤكد', delivered:'مسلّم', cancelled:'ملغي' };
const PAY_ICON      = { cash:'💵', check:'🧾', credit:'💳', installment:'📅' };

// ── helper: format date nice ──
const niceDateDiff = (d) => {
  if (!d) return null;
  const diff = Math.ceil((new Date(d) - new Date()) / 86400000);
  if (diff < 0)  return { label: `متأخر ${Math.abs(diff)} يوم`, color: 'var(--danger)' };
  if (diff === 0) return { label: 'اليوم',                        color: 'var(--warning)' };
  if (diff <= 7)  return { label: `بعد ${diff} أيام`,             color: 'var(--warning)' };
  return null;
};

// ══════════════════════════════════════
// PRINT INVOICE (unchanged logic)
// ══════════════════════════════════════
async function printInvoice(orderId) {
  try {
    const r = await API.get('/orders/' + orderId + '/invoice');
    const d = r.data;
    const win = window.open('', '_blank', 'width=900,height=700');
    const _d = new Date();
    const today = String(_d.getDate()).padStart(2,'0')+'/'+String(_d.getMonth()+1).padStart(2,'0')+'/'+_d.getFullYear();
    const fmtD  = (s) => { if(!s) return '-'; const x=new Date(s); return String(x.getDate()).padStart(2,'0')+'/'+String(x.getMonth()+1).padStart(2,'0')+'/'+x.getFullYear(); };
    const fmtN  = (n) => parseFloat(n||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
    const groupMap = {};
    (d.items||[]).forEach(item => {
      const qty = item.actual_quantity != null ? item.actual_quantity : item.quantity;
      const key = (item.brand_name||'')+'__'+(item.product_type||item.product_name||item.finished_product_name||'')+'__'+item.unit_price;
      if (!groupMap[key]) groupMap[key] = { hs_code:item.hs_code||'33030010', brand:item.brand_name||'', product_type:item.product_type||item.product_name||item.finished_product_name||'', unit_price:item.unit_price, qty:0 };
      groupMap[key].qty += qty;
    });
    const gi = Object.values(groupMap);
    const totalQty = gi.reduce((s,i)=>s+i.qty,0);
    const subtotal  = gi.reduce((s,i)=>s+(i.qty*i.unit_price),0);
    const shipping  = parseFloat(d.shipping_cost)||0;
    const otherTax  = parseFloat(d.other_tax)||0;
    const grandTotal= subtotal-(d.discount||0)+shipping+otherTax;
    const itemRows  = gi.map(i=>'<tr><td>'+i.hs_code+'</td><td>'+i.brand+'</td><td>'+i.product_type+'</td><td class="center">'+i.qty+'</td><td class="center">'+fmtN(i.unit_price)+'</td><td class="center">'+fmtN(i.qty*i.unit_price)+'</td></tr>').join('');
    const payRows   = (d.payments&&d.payments.length>0)?d.payments.map(p=>'<tr><td style="padding:4px 8px;border-bottom:1px solid #eee">'+fmtD(p.payment_date)+'</td><td style="padding:4px 8px;border-bottom:1px solid #eee">'+(p.payment_type==='cash'?'Cash':p.payment_type==='check'?'Check':'Transfer')+'</td><td style="padding:4px 8px;border-bottom:1px solid #eee;text-align:right;color:#16a34a;font-weight:700">'+fmtN(p.amount)+'</td></tr>').join(''):'';
    const paySec    = (d.payments&&d.payments.length>0)?('<div style="margin-top:10px;margin-bottom:8px"><div style="font-weight:900;font-size:11px;color:#b5451b;margin-bottom:4px">PAYMENT HISTORY</div><table style="width:50%;border-collapse:collapse;font-size:11px"><thead><tr style="background:#b5451b;color:#fff"><th style="padding:5px 8px;text-align:left">Date</th><th style="padding:5px 8px;text-align:left">Type</th><th style="padding:5px 8px;text-align:right">Amount USD</th></tr></thead><tbody>'+payRows+'<tr style="background:#f5f5f5"><td colspan="2" style="padding:5px 8px;font-weight:700">Total Paid</td><td style="padding:5px 8px;text-align:right;font-weight:800;color:#16a34a">'+fmtN(d.paid_amount||0)+'</td></tr><tr style="background:#fee2e2"><td colspan="2" style="padding:5px 8px;font-weight:700;color:#dc2626">Remaining</td><td style="padding:5px 8px;text-align:right;font-weight:800;color:#dc2626">'+fmtN(d.remaining_amount||0)+'</td></tr></tbody></table></div>'):'';
    const css='*{margin:0;padding:0;box-sizing:border-box}body{font-family:Arial,sans-serif;font-size:12px;color:#111;padding:20px}.red-bar{background:#b5451b;color:#fff;text-align:center;font-weight:900;font-size:1rem;padding:6px;letter-spacing:2px;margin:8px 0}.buyer-table{width:100%;border-collapse:collapse;margin-bottom:8px;font-size:11px}.buyer-table td{padding:3px 6px;border-bottom:1px solid #eee}.buyer-table .lbl{font-weight:700;width:130px}.items-table{width:100%;border-collapse:collapse;margin-bottom:0;font-size:11px}.items-table thead tr{background:#b5451b;color:#fff}.items-table thead th{padding:7px 6px;text-align:center;font-size:11px}.items-table thead th:nth-child(3){text-align:left}.items-table tbody tr{border-bottom:1px solid #e0e0e0}.items-table tbody td{padding:5px 6px}.items-table tbody td:nth-child(3){text-align:left}.items-table tfoot td{padding:5px 6px;font-weight:700}.center{text-align:center}.terms-table{width:100%;border-collapse:collapse}.terms-table td{padding:4px 6px;border:1px solid #ddd}.terms-table .red-lbl{background:#b5451b;color:#fff;font-weight:700;padding:4px 8px;white-space:nowrap}.terms-table .red-val{background:#fde9e9;color:#b5451b;font-weight:700;padding:4px 8px}.totals-table{width:100%;border-collapse:collapse}.totals-table td{padding:4px 8px;border:1px solid #ddd;font-size:11px}.totals-table .lbl{background:#f5f5f5;font-weight:700}.totals-table .val{text-align:right;min-width:80px}.totals-table .total-row td{background:#b5451b;color:#fff;font-weight:900;font-size:12px}.bank-section{margin-top:10px;border:2px solid #b5451b;border-radius:4px;padding:10px 14px;font-size:11px}.bank-title{font-weight:900;color:#b5451b;font-size:12px;margin-bottom:6px}.bank-row{padding:2px 0}.bank-row .lbl{font-weight:700;display:inline-block;width:110px}.footer-note{margin-top:10px;font-size:10px;color:#555;text-align:center;font-style:italic;border-top:1px solid #eee;padding-top:6px}@media print{body{padding:10px}@page{margin:0.8cm;size:A4}}';
    win.document.write('<!DOCTYPE html><html lang="en" dir="ltr"><head><meta charset="utf-8"/><title>Proforma Invoice - '+d.order_number+'</title><style>'+css+'</style></head><body><table style="width:100%;margin-bottom:6px"><tr><td style="width:33%;font-size:10px"><strong>Address:</strong> Yakuplu, Haramidere Sanayi Sitesi (M) Blok no.325, 34524 . Beylikduzu / Istanbul</td><td style="width:34%;text-align:center"><img src="/logo.png" style="height:60px;object-fit:contain;" /></td><td style="width:33%;text-align:right;font-size:10px"><div><strong>Date:</strong> '+today+'</div><div><strong>No:</strong> '+d.order_number+'</div></td></tr></table><table style="width:100%;font-size:10px;margin-bottom:4px;border-bottom:1px solid #eee;padding-bottom:4px"><tr><td style="width:28%"><strong>Tel :</strong> +90 537 305 73 12</td><td style="width:32%"><strong>E-mail :</strong> info@jasmine-perfumes.com.tr</td><td style="width:30%;text-align:center">www.jasmine-perfumes.com.tr</td><td style="width:20%;text-align:right">Page : 1</td></tr></table><div style="font-size:10px;margin-bottom:6px;font-style:italic">Further to your request, we have the pleasure to offer followings</div><div class="red-bar">PROFORMA INVOICE</div><div style="font-weight:900;font-size:11px;margin:6px 0 4px">BUYER / CONSIGNEE</div><table class="buyer-table"><tr><td class="lbl">Company Name :</td><td><strong>'+(d.customer_name||'')+'</strong></td><td style="width:40%"></td></tr><tr><td class="lbl">Address:</td><td>'+(d.customer_address||'')+'</td><td></td></tr><tr><td class="lbl">Phone / GSM:</td><td>'+(d.customer_phone||'')+'</td><td></td></tr><tr><td class="lbl">Country:</td><td>'+(d.customer_country||'')+'</td><td></td></tr></table><table class="items-table"><thead><tr><th style="width:10%">H.S CODE</th><th style="width:14%">Brand Name</th><th style="width:38%">DESCRIPTION</th><th style="width:8%">QTY</th><th style="width:14%">Unit Price USD</th><th style="width:16%">Total USD</th></tr></thead><tbody>'+itemRows+'</tbody><tfoot><tr style="border-top:2px solid #b5451b"><td colspan="3" style="font-size:10px">THE GOODS ARE OF TURKISH ORIGIN</td><td class="center" style="font-weight:900">'+totalQty+'</td><td style="text-align:right;font-weight:900;color:#b5451b">Total:</td><td class="center" style="font-weight:900">'+fmtN(subtotal)+'</td></tr></tfoot></table><table style="width:100%;border-collapse:collapse;margin-top:4px;font-size:11px"><tr><td style="width:58%;padding-right:10px;padding-top:4px"><table class="terms-table"><tr><td class="red-lbl">Delivery Term</td><td>: EXW ( EX works )</td></tr><tr><td class="red-lbl">Payment Terms</td><td>: 70% With PO - 30% Before Shipping</td></tr><tr><td class="red-lbl" style="background:#fde9e9;color:#b5451b">Time of Delivery</td><td class="red-val">: 25 Business Day After First Payment</td></tr><tr><td class="red-lbl">VALIDITY</td><td>: This Offer is Valid for 15 Days</td></tr></table></td><td style="width:42%;padding-top:4px"><table class="totals-table"><tr><td class="lbl">Other Tax</td><td class="val">'+fmtN(otherTax)+'</td></tr><tr><td class="lbl">Shipping</td><td class="val">'+fmtN(shipping)+'</td></tr><tr class="total-row"><td>Total</td><td class="val">'+fmtN(grandTotal)+'</td></tr></table></td></tr></table>'+paySec+'<div class="bank-section"><div class="bank-title">BANK COORDINATES</div><div class="bank-row"><span class="lbl">BENEFICIARY</span>: JASMİNE KOZMETİK İMALAT SANAYİ T İCARET LİMİTED ŞİRKETİ</div><div class="bank-row"><span class="lbl">BANK</span>: ALBARAKA TURK PARTICIPATION BANK</div><div class="bank-row"><span class="lbl">SWIFT</span>: BTFHTRISXXX</div><div class="bank-row"><span class="lbl">IBAN NO ( USD )</span>: TR 47 0020 3000 0210 2297 0000 02</div><div class="bank-row"><span class="lbl">BANK ADDRESS</span>: Mustafa Kemal Pasa, Firuzkov Blv. No:103, 34320 Avcılar / ZIP CODE:34320 - ISTANBUL</div></div><div class="footer-note">We trust we have interpreted your requirements correctly, if you require any further information or assistance please do not hesitate to contact us.</div></body></html>');
    win.document.close();
    setTimeout(() => { win.focus(); win.print(); }, 800);
  } catch(e) { alert('حدث خطأ أثناء تحميل الفاتورة'); }
}

// ══════════════════════════════════════
// ORDER DETAIL MODAL
// ══════════════════════════════════════
function OrderDetail({ detail, onClose, onPayment, onStatusChange, isManager, onReload }) {
  const paidPct = detail.total > 0 ? Math.min(100, (detail.paid_amount / detail.total) * 100) : 0;
  const dueDiff = niceDateDiff(detail.due_date);

  const handleCostBlur = async (field, value) => {
    const costs = {
      shipping_cost: field === 'shipping_cost' ? +value : (detail.shipping_cost || 0),
      other_tax:     field === 'other_tax'     ? +value : (detail.other_tax || 0),
    };
    try { await API.put('/orders/' + detail.id + '/costs', costs); onReload(); }
    catch(e) { alert('حدث خطأ'); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 740 }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="modal-header">
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <div style={{
              background: 'var(--brand-light)', color: 'var(--brand)',
              padding: '4px 12px', borderRadius: 20, fontSize: '0.78rem', fontWeight: 700
            }}>
              {detail.order_number}
            </div>
            <span className={`badge ${STATUS_BADGE[detail.status]}`}>{STATUS_LABEL[detail.status]}</span>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">

          {/* Info Grid */}
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 18
          }}>
            {[
              { label: 'العميل',       value: detail.customer_name, bold: true },
              { label: 'الهاتف',       value: detail.customer_phone || '-' },
              { label: 'نوع الدفع',    value: PAY_ICON[detail.payment_type] + ' ' + (PAYMENT_TYPES[detail.payment_type] || detail.payment_type) },
              { label: 'الإجمالي',     value: fmt.currency(detail.total), color: 'var(--ink)' },
              { label: 'المدفوع',      value: fmt.currency(detail.paid_amount), color: 'var(--success)' },
              { label: 'المتبقي',      value: fmt.currency(detail.remaining_amount), color: detail.remaining_amount > 0 ? 'var(--danger)' : 'var(--success)' },
            ].map((item, i) => (
              <div key={i} style={{
                background: 'var(--surface-2)', borderRadius: 10,
                padding: '10px 13px', border: '1px solid var(--border-2)'
              }}>
                <div style={{ fontSize: '0.7rem', color: 'var(--muted)', marginBottom: 3, fontWeight: 600 }}>{item.label}</div>
                <div style={{ fontWeight: item.bold ? 700 : 600, color: item.color || 'var(--ink)', fontSize: '0.9rem' }}>{item.value}</div>
              </div>
            ))}
          </div>

          {/* Payment Progress */}
          <div style={{ marginBottom: 18 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 6 }}>
              <span style={{ fontSize:'0.78rem', fontWeight:700, color:'var(--muted)' }}>نسبة التحصيل</span>
              <span style={{ fontSize:'0.82rem', fontWeight:800, color: paidPct >= 100 ? 'var(--success)' : paidPct >= 50 ? 'var(--warning)' : 'var(--danger)' }}>
                {paidPct.toFixed(0)}%
              </span>
            </div>
            <div className="progress">
              <div className="progress-bar" style={{
                width: paidPct + '%',
                background: paidPct >= 100 ? 'var(--success)' : paidPct >= 50 ? 'var(--warning)' : 'var(--danger)'
              }} />
            </div>
            {dueDiff && (
              <div style={{ marginTop: 5, fontSize:'0.75rem', fontWeight:700, color: dueDiff.color }}>
                ⏰ {dueDiff.label}
              </div>
            )}
          </div>

          {/* Products */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize:'0.78rem', fontWeight:700, color:'var(--muted)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.5px' }}>
              المنتجات
            </div>
            <div className="table-container" style={{ boxShadow:'none', border:'1px solid var(--border-2)' }}>
              <table>
                <thead>
                  <tr>
                    <th>المنتج</th><th>الرائحة</th>
                    <th style={{ textAlign:'center' }}>الكمية</th>
                    <th style={{ textAlign:'center' }}>السعر</th>
                    <th style={{ textAlign:'center' }}>الإجمالي</th>
                  </tr>
                </thead>
                <tbody>
                  {detail.items?.map(i => (
                    <tr key={i.id}>
                      <td className="font-bold" style={{ fontSize:'0.855rem' }}>{i.finished_product_name || i.product_name}</td>
                      <td>
                        {i.flavor_name
                          ? <span style={{ background:'var(--brand-light)', color:'var(--brand)', borderRadius:20, padding:'2px 9px', fontSize:'0.73rem', fontWeight:700 }}>🌸 {i.flavor_name}</span>
                          : <span className="text-muted">—</span>}
                      </td>
                      <td style={{ textAlign:'center', fontWeight:700 }}>{i.actual_quantity != null ? i.actual_quantity : i.quantity} {i.unit||'pcs'}</td>
                      <td style={{ textAlign:'center' }}>{fmt.currency(i.unit_price)}</td>
                      <td style={{ textAlign:'center' }} className="text-success font-bold">{fmt.currency(i.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Payments */}
          {detail.payments?.length > 0 && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize:'0.78rem', fontWeight:700, color:'var(--muted)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.5px' }}>
                سجل الدفعات
              </div>
              <div className="table-container" style={{ boxShadow:'none', border:'1px solid var(--border-2)' }}>
                <table>
                  <thead><tr><th>المبلغ</th><th>النوع</th><th>التاريخ</th></tr></thead>
                  <tbody>
                    {detail.payments.map(p => (
                      <tr key={p.id}>
                        <td className="text-success font-bold">{fmt.currency(p.amount)}</td>
                        <td><span className="badge badge-info">{PAYMENT_TYPES[p.payment_type] || p.payment_type}</span></td>
                        <td className="text-muted">{fmt.date(p.payment_date)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Additional Costs */}
          {isManager && (
            <div style={{
              background: 'var(--surface-2)', borderRadius: 10,
              padding: '13px 16px', border: '1px solid var(--border-2)'
            }}>
              <div style={{ fontSize:'0.78rem', fontWeight:700, color:'var(--muted)', marginBottom:10, textTransform:'uppercase', letterSpacing:'0.5px' }}>
                تكاليف إضافية
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <div className="form-group" style={{ margin:0 }}>
                  <label style={{ fontSize:'0.78rem' }}>Shipping Cost ($)</label>
                  <input type="number" min="0" step="0.01"
                    defaultValue={detail.shipping_cost || 0}
                    onBlur={e => handleCostBlur('shipping_cost', e.target.value)} />
                </div>
                <div className="form-group" style={{ margin:0 }}>
                  <label style={{ fontSize:'0.78rem' }}>Other Tax ($)</label>
                  <input type="number" min="0" step="0.01"
                    defaultValue={detail.other_tax || 0}
                    onBlur={e => handleCostBlur('other_tax', e.target.value)} />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer Actions */}
        <div className="modal-footer" style={{ flexWrap:'wrap', gap:8 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => printInvoice(detail.id)}>
            🧾 فاتورة
          </button>
          {isManager && detail.remaining_amount > 0 && detail.status !== 'cancelled' && (
            <button className="btn btn-success btn-sm" onClick={() => { onPayment(detail); onClose(); }}>
              💰 دفعة
            </button>
          )}
          {isManager && detail.status === 'pending' && (
            <button className="btn btn-primary btn-sm" onClick={() => onStatusChange(detail.id, 'confirmed')}>
              ✓ تأكيد
            </button>
          )}
          {isManager && ['pending','confirmed'].includes(detail.status) && (
            <button className="btn btn-success btn-sm" onClick={() => onStatusChange(detail.id, 'delivered')}>
              📦 تسليم
            </button>
          )}
          {isManager && detail.status !== 'cancelled' && (
            <button className="btn btn-danger btn-sm" onClick={() => onStatusChange(detail.id, 'cancelled')}>
              ✕ إلغاء
            </button>
          )}
          <button className="btn btn-ghost btn-sm" onClick={onClose} style={{ marginRight:'auto' }}>إغلاق</button>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════
// MAIN COMPONENT
// ══════════════════════════════════════
export default function Orders() {
  const { user } = useAuth();
  const [orders,        setOrders]        = useState([]);
  const [customers,     setCustomers]     = useState([]);
  const [search,        setSearch]        = useState('');
  const [filterStatus,  setFilterStatus]  = useState('');
  const [page,          setPage]          = useState(1);
  const PER_PAGE = 50;
  useEffect(() => { setPage(1); }, [search, filterStatus]);
  const [modal,         setModal]         = useState(false);
  const [detail,        setDetail]        = useState(null);
  const [payModal,      setPayModal]      = useState(null);
  const [form,          setForm]          = useState(EMPTY_FORM);
  const [payForm,       setPayForm]       = useState(EMPTY_PAY);
  const [error,         setError]         = useState('');
  const [loading,       setLoading]       = useState(false);
  const [stockWarnings, setStockWarnings] = useState([]);
  const [bulkModal, setBulkModal] = useState(false);
  const [bulkProducts, setBulkProducts] = useState([]);
  const [bulkStep, setBulkStep] = useState('brand'); // brand|type|products
  const [bulkBrand, setBulkBrand] = useState('');
  const [bulkType, setBulkType] = useState('');
  const [bulkSelected, setBulkSelected] = useState({}); // {product_id: {qty, price}}
  const [bulkDefaultQty, setBulkDefaultQty] = useState(1);
  const [bulkDefaultPrice, setBulkDefaultPrice] = useState(0);
  const [bulkSearch, setBulkSearch] = useState('');
  const isManager = ['admin','sales_manager'].includes(user?.role);

  const load = () => {
    API.get('/orders').then(r => setOrders(r.data));
    API.get('/customers').then(r => setCustomers(r.data));
  };
  useEffect(() => {
    load();
    API.get('/finished-products').then(r => setBulkProducts(r.data));
  }, []);

  const loadDetail = (id) => API.get('/orders/' + id).then(r => setDetail(r.data));

  const deleteOrder = async (o) => {
    if (!window.confirm('حذف الطلب ' + o.order_number + '؟\nهذا الإجراء لا يمكن التراجع عنه.')) return;
    try { await API.delete('/orders/' + o.id); load(); }
    catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const updateStatus = async (id, status) => {
    await API.put('/orders/' + id + '/status', { status });
    setDetail(d => d ? { ...d, status } : d);
    load();
  };

  // Form helpers
  const addItem    = () => setForm(f => ({ ...f, items: [...f.items, { finished_product_id:'', flavor_id:'', product_name:'', quantity:1, unit_price:0 }] }));
  const removeItem = (i) => setForm(f => ({ ...f, items: f.items.filter((_,idx) => idx !== i) }));
  const updateItem = (i, field, val) => {
    const items = [...form.items];
    items[i] = { ...items[i], [field]: val };
    setForm(f => ({ ...f, items }));
  };
  const pickProduct = (i, { product, flavor }) => {
    const items = [...form.items];
    items[i] = { ...items[i], finished_product_id: product?.id||'', flavor_id: flavor?.id||'', product_name: product?(product.name+(flavor?' - '+flavor.name:'')):'', unit_price: product?.price||0 };
    setForm(f => { const nf = { ...f, items }; setTimeout(() => checkStock(nf.items), 100); return nf; });
  };

  // ===== Bulk Picker helpers =====
  const openBulkModal = () => {
    setBulkStep('brand');
    setBulkBrand('');
    setBulkType('');
    setBulkSelected({});
    setBulkSearch('');
    setBulkDefaultQty(1);
    setBulkDefaultPrice(0);
    setBulkModal(true);
  };

  const bulkBrands = [...new Set(bulkProducts.map(p => p.brand).filter(Boolean))].sort();
  const bulkTypes = [...new Set(bulkProducts.filter(p => p.brand === bulkBrand).map(p => p.product_type).filter(Boolean))].sort();
  const bulkFiltered = bulkProducts.filter(p =>
    p.brand === bulkBrand && p.product_type === bulkType &&
    (!bulkSearch || p.name.toLowerCase().includes(bulkSearch.toLowerCase()))
  );

  const getFlavorName = (p) => {
    if (!p.product_type) return p.name;
    return p.name.replace(p.product_type, '').trim() || p.name;
  };

  const toggleBulkProduct = (p) => {
    setBulkSelected(prev => {
      const n = { ...prev };
      if (n[p.id]) delete n[p.id];
      else n[p.id] = { product: p, qty: bulkDefaultQty, price: p.price || bulkDefaultPrice };
      return n;
    });
  };

  const selectAllBulk = () => {
    if (Object.keys(bulkSelected).length === bulkFiltered.length) {
      setBulkSelected({});
    } else {
      const n = {};
      bulkFiltered.forEach(p => { n[p.id] = { product: p, qty: bulkDefaultQty, price: p.price || bulkDefaultPrice }; });
      setBulkSelected(n);
    }
  };

  const applyDefaultQty = () => {
    setBulkSelected(prev => {
      const n = { ...prev };
      Object.keys(n).forEach(id => { n[id] = { ...n[id], qty: bulkDefaultQty }; });
      return n;
    });
  };

  const applyDefaultPrice = () => {
    setBulkSelected(prev => {
      const n = { ...prev };
      Object.keys(n).forEach(id => { n[id] = { ...n[id], price: bulkDefaultPrice }; });
      return n;
    });
  };

  const addBulkToOrder = () => {
    const newItems = Object.values(bulkSelected).map(({ product, qty, price }) => ({
      finished_product_id: product.id,
      flavor_id: '',
      product_name: product.name,
      quantity: qty || 1,
      unit_price: price || 0,
    }));
    setForm(f => {
      const existingEmpty = f.items.filter(i => !i.finished_product_id);
      const existingFilled = f.items.filter(i => i.finished_product_id);
      const nf = { ...f, items: [...existingFilled, ...newItems, ...(existingEmpty.length ? [] : [])] };
      setTimeout(() => checkStock(nf.items), 100);
      return nf;
    });
    setBulkModal(false);
    setBulkSelected({});
  };

  const brandColors2 = {
    'JASMINE': '#6c3fc5', 'LUVEAL': '#e91e8c', 'CAVAYELO': '#0891b2',
    'MAROTA': '#d97706', 'PURE PASSION': '#dc2626', 'JASMINE NICHE': '#7c3aed', 'VILARA': '#059669',
  };
  const bColor = (b) => brandColors2[b] || '#6d28d9';

  const checkStock = async (items) => {
    const valid = items.filter(i => i.finished_product_id && i.quantity > 0);
    if (!valid.length) { setStockWarnings([]); return; }
    try {
      const r = await API.post('/bom/calculate', { items: valid.map(i => ({ finished_product_id: i.finished_product_id, flavor_id: i.flavor_id||null, quantity: i.quantity })) });
      const warns = r.data.materials.filter(m => !m.sufficient).map(m => m.name + ': متوفر ' + m.available + ' | مطلوب ' + m.total_needed);
      if (r.data.warnings?.length) warns.push(...r.data.warnings);
      setStockWarnings(warns);
    } catch { setStockWarnings([]); }
  };

  const subtotal = form.items.reduce((s,i) => s + (i.quantity * (i.unit_price||0)), 0);
  const total    = subtotal - (form.discount||0);

  const save = async () => {
    if (!form.customer_id) return setError('اختر العميل');
    if (form.items.some(i => !i.finished_product_id || i.quantity <= 0)) return setError('تحقق من المنتجات والكميات');
    setError(''); setLoading(true);
    try { await API.post('/orders', form); setModal(false); load(); }
    catch(e) { setError(e.response?.data?.error || 'حدث خطأ'); }
    finally { setLoading(false); }
  };

  const submitPayment = async () => {
    if (!payForm.amount || payForm.amount <= 0) return;
    try {
      await API.post('/payments', { ...payForm, order_id: payModal.id });
      setPayModal(null); setPayForm(EMPTY_PAY); load();
      if (detail) loadDetail(detail.id);
    } catch(e) { alert(e.response?.data?.error || 'حدث خطأ'); }
  };

  const filtered = orders.filter(o =>
    ((o.order_number||'').includes(search) || (o.customer_name||'').includes(search)) &&
    (!filterStatus || o.status === filterStatus)
  );
  const pagedOrders = filtered.slice((page-1)*PER_PAGE, page*PER_PAGE);

  // Summary counts
  const counts = { pending: 0, confirmed: 0, delivered: 0, cancelled: 0 };
  orders.forEach(o => { if (counts[o.status] !== undefined) counts[o.status]++; });
  const totalDebt = orders.filter(o => o.status !== 'cancelled').reduce((s,o) => s + (o.remaining_amount||0), 0);

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">الطلبات</h1>
          <div className="page-title-sub">{orders.length} طلب إجمالي</div>
        </div>
        <button className="btn btn-primary" onClick={() => { setForm(EMPTY_FORM); setError(''); setModal(true); }}>
          + طلب جديد
        </button>
      </div>

      {/* Summary Bar */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:10, marginBottom:20 }}>
        {[
          { label:'معلق',      count: counts.pending,   color:'var(--warning)',  bg:'var(--warning-bg)',  status:'pending'   },
          { label:'مؤكد',      count: counts.confirmed, color:'var(--info)',     bg:'var(--info-bg)',     status:'confirmed' },
          { label:'مسلّم',     count: counts.delivered, color:'var(--success)',  bg:'var(--success-bg)', status:'delivered' },
          { label:'ملغي',      count: counts.cancelled, color:'var(--muted)',    bg:'var(--surface-3)',   status:'cancelled' },
        ].map(s => (
          <div key={s.status}
            onClick={() => setFilterStatus(filterStatus === s.status ? '' : s.status)}
            style={{
              background: filterStatus === s.status ? s.bg : 'var(--surface)',
              border: `1.5px solid ${filterStatus === s.status ? s.color : 'var(--border)'}`,
              borderRadius: 10, padding: '12px 16px', cursor: 'pointer',
              transition: 'all 0.18s', display:'flex', justifyContent:'space-between', alignItems:'center'
            }}>
            <span style={{ fontSize:'0.82rem', fontWeight:600, color: filterStatus === s.status ? s.color : 'var(--muted)' }}>{s.label}</span>
            <span style={{ fontSize:'1.3rem', fontWeight:800, color: s.color }}>{s.count}</span>
          </div>
        ))}
      </div>

      {/* Search + Debt */}
      <div style={{ display:'flex', gap:10, marginBottom:16, alignItems:'center', flexWrap:'wrap' }}>
        <input className="search-input" style={{ flex:1, minWidth:200 }}
          placeholder="🔍 بحث برقم الطلب أو اسم العميل..."
          value={search} onChange={e => setSearch(e.target.value)} />
        {isManager && totalDebt > 0 && (
          <div style={{ background:'var(--danger-bg)', border:'1px solid var(--danger)', borderRadius:10, padding:'8px 16px', fontSize:'0.82rem', fontWeight:700, color:'var(--danger)', whiteSpace:'nowrap' }}>
            إجمالي الديون: {fmt.currency(totalDebt)}
          </div>
        )}
      </div>


            {/* Detail Modal */}
      {detail && (
        <OrderDetail
          detail={detail}
          isManager={isManager}
          onClose={() => setDetail(null)}
          onPayment={(o) => { setPayModal(o); setDetail(null); }}
          onStatusChange={async (id, status) => { await updateStatus(id, status); setDetail(null); }}
          onReload={() => loadDetail(detail.id)}
        />
      )}

      {/* Payment Modal */}
      {payModal && (
        <div className="modal-overlay" onClick={() => setPayModal(null)}>
          <div className="modal" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">💰 تسجيل دفعة</span>
              <button className="modal-close" onClick={() => setPayModal(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ background:'var(--success-bg)', border:'1px solid var(--success)', borderRadius:10, padding:'12px 16px', marginBottom:16 }}>
                <div style={{ fontSize:'0.75rem', color:'var(--success)', fontWeight:700, marginBottom:2 }}>المتبقي للتحصيل</div>
                <div style={{ fontSize:'1.4rem', fontWeight:800, color:'var(--success)' }}>{fmt.currency(payModal.remaining_amount)}</div>
              </div>
              <div className="form-grid">
                <div className="form-group span-2">
                  <label>المبلغ <span className="required">*</span></label>
                  <input type="number" value={payForm.amount}
                    onChange={e => setPayForm({ ...payForm, amount: +e.target.value })}
                    max={payModal.remaining_amount} min={0} />
                </div>
                <div className="form-group">
                  <label>نوع الدفع</label>
                  <select value={payForm.payment_type} onChange={e => setPayForm({ ...payForm, payment_type: e.target.value })}>
                    <option value="cash">💵 نقدي</option>
                    <option value="check">🧾 شيك</option>
                    <option value="transfer">🏦 تحويل</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>التاريخ</label>
                  <input type="date" value={payForm.payment_date} onChange={e => setPayForm({ ...payForm, payment_date: e.target.value })} />
                </div>
                {payForm.payment_type === 'check' && (
                  <div className="form-group span-2">
                    <label>رقم الشيك</label>
                    <input value={payForm.check_number} onChange={e => setPayForm({ ...payForm, check_number: e.target.value })} />
                  </div>
                )}
                <div className="form-group span-2">
                  <label>ملاحظات</label>
                  <textarea value={payForm.notes} onChange={e => setPayForm({ ...payForm, notes: e.target.value })} rows={2} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-success" onClick={submitPayment} disabled={!payForm.amount || payForm.amount <= 0}>
                💾 حفظ الدفعة
              </button>
              <button className="btn btn-ghost" onClick={() => setPayModal(null)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* New Order Modal */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" style={{ maxWidth: 780 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">طلب جديد</span>
              <button className="modal-close" onClick={() => setModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              {error && <div className="alert alert-danger">{error}</div>}

              <div className="form-grid" style={{ marginBottom: 16 }}>
                <div className="form-group">
                  <label>العميل <span className="required">*</span></label>
                  <select value={form.customer_id} onChange={e => setForm({ ...form, customer_id: e.target.value })}>
                    <option value="">— اختر العميل —</option>
                    {customers.map(c => <option key={c.id} value={c.id}>{c.name}{c.phone ? ' · ' + c.phone : ''}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>نوع الدفع</label>
                  <select value={form.payment_type} onChange={e => setForm({ ...form, payment_type: e.target.value })}>
                    <option value="cash">💵 نقدي</option>
                    <option value="credit">💳 آجل</option>
                    <option value="installment">📅 تقسيط</option>
                    <option value="check">🧾 شيك</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>تاريخ الاستحقاق</label>
                  <input type="date" value={form.due_date} onChange={e => setForm({ ...form, due_date: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>الخصم ($)</label>
                  <input type="number" value={form.discount} onChange={e => setForm({ ...form, discount: +e.target.value })} min={0} />
                </div>
                <div className="form-group span-2">
                  <label>ملاحظات</label>
                  <textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} rows={2} />
                </div>
              </div>

              {/* Products */}
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                <div style={{ fontWeight:700, fontSize:'0.88rem' }}>المنتجات <span style={{ color:'var(--muted)', fontWeight:400, fontSize:'0.78rem' }}>{form.items.filter(i=>i.finished_product_id).length} منتج</span></div>
                <div style={{ display:'flex', gap:6 }}>
                  <button className="btn btn-sm btn-primary" onClick={openBulkModal}>⚡ إضافة متعدد</button>
                  <button className="btn btn-sm btn-outline" onClick={addItem}>+ منتج واحد</button>
                </div>
              </div>

              {form.items.map((item, i) => (
                <div key={i} style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr auto', gap:8, marginBottom:8, alignItems:'end' }}>
                  <div className="form-group" style={{ margin:0 }}>
                    {i === 0 && <label>المنتج والرائحة</label>}
                    <FinishedProductPicker
                      value={item.finished_product_id} flavorValue={item.flavor_id}
                      onChange={({ product, flavor }) => pickProduct(i, { product, flavor })}
                      placeholder="اختر المنتج..." />
                  </div>
                  <div className="form-group" style={{ margin:0 }}>
                    {i === 0 && <label>الكمية</label>}
                    <input type="number" value={item.quantity} min={1}
                      onChange={e => updateItem(i, 'quantity', +e.target.value)} />
                  </div>
                  <div className="form-group" style={{ margin:0 }}>
                    {i === 0 && <label>السعر ($)</label>}
                    <input type="number" value={item.unit_price} min={0}
                      onChange={e => updateItem(i, 'unit_price', +e.target.value)} />
                  </div>
                  <button className="btn btn-sm btn-danger btn-icon"
                    style={{ marginTop: i === 0 ? 22 : 0 }}
                    onClick={() => removeItem(i)} disabled={form.items.length === 1}>✕</button>
                </div>
              ))}

              {/* Totals */}
              <div style={{
                background: 'var(--surface-2)', borderRadius: 10,
                padding: '13px 16px', border: '1px solid var(--border-2)', marginTop: 12
              }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                  <span className="text-muted" style={{ fontSize:'0.85rem' }}>المجموع الفرعي</span>
                  <span className="font-bold">{fmt.currency(subtotal)}</span>
                </div>
                {form.discount > 0 && (
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                    <span className="text-muted" style={{ fontSize:'0.85rem' }}>الخصم</span>
                    <span className="text-danger font-bold">- {fmt.currency(form.discount)}</span>
                  </div>
                )}
                <div style={{ display:'flex', justifyContent:'space-between', paddingTop:8, borderTop:'1px solid var(--border)' }}>
                  <span style={{ fontWeight:700 }}>الإجمالي</span>
                  <span style={{ fontWeight:800, fontSize:'1.1rem', color:'var(--success)' }}>{fmt.currency(total)}</span>
                </div>
              </div>

              {/* Stock Warnings */}
              {stockWarnings.length > 0 && (
                <div style={{ background:'var(--warning-bg)', border:'1px solid #f0c070', borderRadius:10, padding:'12px 16px', marginTop:12 }}>
                  <div style={{ fontWeight:700, color:'var(--warning)', marginBottom:6, fontSize:'0.855rem' }}>⚠️ تحذير مخزون غير كافٍ</div>
                  {stockWarnings.map((w, i) => (
                    <div key={i} style={{ fontSize:'0.8rem', color:'#7a3f0a', marginTop:3, display:'flex', alignItems:'center', gap:6 }}>
                      <span style={{ width:5, height:5, borderRadius:'50%', background:'var(--warning)', flexShrink:0, display:'inline-block' }}/>
                      {w}
                    </div>
                  ))}
                  <div style={{ fontSize:'0.76rem', color:'var(--muted)', marginTop:8 }}>يمكنك المتابعة، لكن تأكد من توفر المواد قبل الإنتاج.</div>
                </div>
              )}
            </div>
            {/* Bulk Modal داخل مودال الطلب */}
            {/* Bulk Product Picker Modal */}
            {bulkModal && (
              <div className="modal-overlay" onClick={() => setBulkModal(false)}>
                <div className="modal" style={{ maxWidth: 620 }} onClick={e => e.stopPropagation()}>

                        {/* خطوة 1: البراند */}
                        {bulkStep === 'brand' && (<>
                          <div className="modal-header">
                            <span className="modal-title">⚡ إضافة متعدد — اختر البراند</span>
                            <button className="modal-close" onClick={() => setBulkModal(false)}>✕</button>
                          </div>
                          <div className="modal-body">
                            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                                    {bulkBrands.map(b => (
                                      <div key={b} onClick={() => { setBulkBrand(b); setBulkStep('type'); }}
                                        style={{ padding:'14px 18px', borderRadius:10, cursor:'pointer', border:`2px solid ${bColor(b)}20`, background:`${bColor(b)}08`, display:'flex', justifyContent:'space-between', alignItems:'center' }}
                                        onMouseEnter={e => { e.currentTarget.style.background=`${bColor(b)}18`; e.currentTarget.style.borderColor=bColor(b); }}
                                        onMouseLeave={e => { e.currentTarget.style.background=`${bColor(b)}08`; e.currentTarget.style.borderColor=`${bColor(b)}20`; }}>
                                        <span style={{ background:bColor(b), color:'white', borderRadius:8, padding:'4px 14px', fontWeight:800, fontSize:'0.9rem' }}>{b}</span>
                                        <span style={{ fontSize:'0.8rem', color:'var(--muted)' }}>{bulkProducts.filter(p=>p.brand===b).length} منتج ←</span>
                                      </div>
                                    ))}
                            </div>
                          </div>
                        </>)}

                        {/* خطوة 2: النوع */}
                        {bulkStep === 'type' && (<>
                          <div className="modal-header">
                            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                                    <button onClick={() => setBulkStep('brand')} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'1.1rem', color:'var(--primary)' }}>→</button>
                                    <span className="modal-title">
                                      <span style={{ background:bColor(bulkBrand), color:'white', borderRadius:6, padding:'2px 10px', fontSize:'0.8rem', marginLeft:8 }}>{bulkBrand}</span>
                                      اختر نوع المنتج
                                    </span>
                            </div>
                            <button className="modal-close" onClick={() => setBulkModal(false)}>✕</button>
                          </div>
                          <div className="modal-body">
                            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                                    {bulkTypes.map(t => (
                                      <div key={t} onClick={() => { setBulkType(t); setBulkStep('products'); setBulkSelected({}); setBulkSearch(''); }}
                                        style={{ padding:'12px 16px', borderRadius:8, cursor:'pointer', border:'1.5px solid var(--border)', background:'white', display:'flex', justifyContent:'space-between', alignItems:'center' }}
                                        onMouseEnter={e => { e.currentTarget.style.borderColor='var(--primary)'; e.currentTarget.style.background='var(--primary-light)'; }}
                                        onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.background='white'; }}>
                                        <span style={{ fontWeight:700 }}>📦 {t}</span>
                                        <span style={{ fontSize:'0.8rem', color:'var(--muted)' }}>{bulkProducts.filter(p=>p.brand===bulkBrand&&p.product_type===t).length} رائحة ←</span>
                                      </div>
                                    ))}
                            </div>
                          </div>
                        </>)}

                        {/* خطوة 3: الروائح مع checkboxes */}
                        {bulkStep === 'products' && (<>
                          <div className="modal-header">
                            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                                    <button onClick={() => setBulkStep('type')} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'1.1rem', color:'var(--primary)' }}>→</button>
                                    <span className="modal-title" style={{ fontSize:'0.9rem' }}>
                                      <span style={{ background:bColor(bulkBrand), color:'white', borderRadius:6, padding:'2px 8px', fontSize:'0.75rem', marginLeft:6 }}>{bulkBrand}</span>
                                      {bulkType}
                                    </span>
                            </div>
                            <button className="modal-close" onClick={() => setBulkModal(false)}>✕</button>
                          </div>
                          <div className="modal-body" style={{ padding:'12px 16px' }}>

                            {/* شريط الإعدادات الافتراضية */}
                            <div style={{ background:'#f0fdf4', border:'1px solid #86efac', borderRadius:8, padding:'10px 14px', marginBottom:12, display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
                                    <span style={{ fontSize:'0.82rem', fontWeight:700, color:'#15803d' }}>إعدادات سريعة:</span>
                                    <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                                      <label style={{ fontSize:'0.8rem', color:'var(--muted)' }}>كمية:</label>
                                      <input type="number" value={bulkDefaultQty} min={1}
                                        onChange={e => setBulkDefaultQty(+e.target.value)}
                                        style={{ width:60, padding:'3px 8px', borderRadius:6, border:'1px solid var(--border)', fontSize:'0.85rem' }} />
                                      <button className="btn btn-sm" onClick={applyDefaultQty}
                                        style={{ background:'#15803d', color:'white', border:'none', fontSize:'0.75rem', padding:'3px 8px' }}>تطبيق</button>
                                    </div>
                                    <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                                      <label style={{ fontSize:'0.8rem', color:'var(--muted)' }}>سعر:</label>
                                      <input type="number" value={bulkDefaultPrice} min={0}
                                        onChange={e => setBulkDefaultPrice(+e.target.value)}
                                        style={{ width:70, padding:'3px 8px', borderRadius:6, border:'1px solid var(--border)', fontSize:'0.85rem' }} />
                                      <button className="btn btn-sm" onClick={applyDefaultPrice}
                                        style={{ background:'#15803d', color:'white', border:'none', fontSize:'0.75rem', padding:'3px 8px' }}>تطبيق</button>
                                    </div>
                            </div>

                            {/* بحث + تحديد الكل */}
                            <div style={{ display:'flex', gap:8, marginBottom:10, alignItems:'center' }}>
                                    <input value={bulkSearch} onChange={e => setBulkSearch(e.target.value)}
                                      placeholder="🔍 ابحث برائحة..."
                                      style={{ flex:1, padding:'8px 12px', borderRadius:8, border:'1.5px solid var(--border)', fontSize:'0.875rem' }} />
                                    <button className="btn btn-sm btn-secondary" onClick={selectAllBulk}>
                                      {Object.keys(bulkSelected).length === bulkFiltered.length ? '☐ إلغاء الكل' : '☑ تحديد الكل'}
                                    </button>
                            </div>

                            {/* قائمة الروائح */}
                            <div style={{ maxHeight:340, overflowY:'auto', display:'flex', flexDirection:'column', gap:5 }}>
                                    {bulkFiltered.map(p => {
                                      const sel = bulkSelected[p.id];
                                      const flavor = getFlavorName(p);
                                      return (
                                        <div key={p.id} style={{ borderRadius:8, border:`1.5px solid ${sel ? bColor(bulkBrand) : 'var(--border)'}`, background: sel ? `${bColor(bulkBrand)}08` : 'white', transition:'all 0.1s' }}>
                                                <div style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 12px', cursor:'pointer' }} onClick={() => toggleBulkProduct(p)}>
                                                  {/* Custom checkbox */}
                                                  <div style={{ width:18, height:18, borderRadius:4, border:`2px solid ${sel ? bColor(bulkBrand) : '#d1d5db'}`, background: sel ? bColor(bulkBrand) : 'white', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'all 0.1s' }}>
                                                    {sel && <span style={{ color:'white', fontSize:11, fontWeight:900 }}>✓</span>}
                                                  </div>
                                                  <span style={{ fontWeight: sel ? 700 : 400, fontSize:'0.88rem', flex:1 }}>🌸 {flavor}</span>
                                                  {p.price > 0 && <span style={{ fontSize:'0.78rem', color:'var(--muted)' }}>${p.price}</span>}
                                                </div>
                                                {/* حقول الكمية والسعر لما يكون محدد */}
                                                {sel && (
                                                  <div style={{ display:'flex', gap:8, padding:'0 12px 8px', alignItems:'center' }}>
                                                    <label style={{ fontSize:'0.78rem', color:'var(--muted)', minWidth:32 }}>كمية:</label>
                                                    <input type="number" value={sel.qty} min={1}
                                                            onChange={e => setBulkSelected(prev => ({ ...prev, [p.id]: { ...prev[p.id], qty: +e.target.value } }))}
                                                            onClick={e => e.stopPropagation()}
                                                            style={{ width:70, padding:'3px 8px', borderRadius:6, border:'1px solid var(--border)', fontSize:'0.85rem' }} />
                                                    <label style={{ fontSize:'0.78rem', color:'var(--muted)', minWidth:30 }}>سعر:</label>
                                                    <input type="number" value={sel.price} min={0}
                                                            onChange={e => setBulkSelected(prev => ({ ...prev, [p.id]: { ...prev[p.id], price: +e.target.value } }))}
                                                            onClick={e => e.stopPropagation()}
                                                            style={{ width:80, padding:'3px 8px', borderRadius:6, border:'1px solid var(--border)', fontSize:'0.85rem' }} />
                                                  </div>
                                                )}
                                        </div>
                                      );
                                    })}
                            </div>

                            <div style={{ fontSize:'0.8rem', color:'var(--muted)', marginTop:8, textAlign:'center' }}>
                                    {bulkFiltered.length} رائحة — محدد: {Object.keys(bulkSelected).length}
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button className="btn btn-primary" onClick={addBulkToOrder} disabled={!Object.keys(bulkSelected).length}>
                                    ✅ إضافة {Object.keys(bulkSelected).length} منتج للطلب
                            </button>
                            <button className="btn btn-secondary" onClick={() => setBulkStep('type')}>← تغيير النوع</button>
                            <button className="btn btn-ghost" onClick={() => setBulkModal(false)}>إلغاء</button>
                          </div>
                        </>)}

                </div>
              </div>
            )}

            <div className="modal-footer">
              <button className="btn btn-primary" onClick={save} disabled={loading}>
                {loading ? <><span className="spinner" style={{ width:15, height:15 }} /> جاري الحفظ...</> : '💾 إنشاء الطلب'}
              </button>
              <button className="btn btn-ghost" onClick={() => setModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>رقم الطلب</th>
                <th>العميل</th>
                <th>الإجمالي</th>
                <th>المدفوع</th>
                <th>المتبقي</th>
                <th>الدفع</th>
                <th>الحالة</th>
                <th>التاريخ</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {pagedOrders.map(o => {
                const pct = o.total > 0 ? (o.paid_amount / o.total) * 100 : 0;
                return (
                  <tr key={o.id}>
                    <td>
                      <span style={{ color:'var(--brand)', fontWeight:700, cursor:'pointer', fontSize:'0.845rem' }}
                        onClick={() => loadDetail(o.id)}>
                        {o.order_number}
                      </span>
                    </td>
                    <td className="font-bold" style={{ fontSize:'0.875rem' }}>{o.customer_name}</td>
                    <td className="font-bold">{fmt.currency(o.total)}</td>
                    <td className="text-success">{fmt.currency(o.paid_amount)}</td>
                    <td>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <span className={o.remaining_amount > 0 ? 'text-danger font-bold' : 'text-success font-bold'}>
                          {fmt.currency(o.remaining_amount)}
                        </span>
                        {o.remaining_amount > 0 && (
                          <div style={{ width:36, height:4, background:'var(--surface-3)', borderRadius:2, overflow:'hidden' }}>
                            <div style={{ width: pct + '%', height:'100%', background: pct >= 100 ? 'var(--success)' : pct >= 50 ? 'var(--warning)' : 'var(--danger)', borderRadius:2 }} />
                          </div>
                        )}
                      </div>
                    </td>
                    <td><span className="badge badge-gray">{PAY_ICON[o.payment_type]} {PAYMENT_TYPES[o.payment_type]}</span></td>
                    <td><span className={`badge ${STATUS_BADGE[o.status]}`}>{STATUS_LABEL[o.status]}</span></td>
                    <td className="text-muted" style={{ fontSize:'0.8rem' }}>{fmt.date(o.created_at)}</td>
                    <td>
                      <div className="td-actions">
                        <button className="btn btn-sm btn-secondary" onClick={() => loadDetail(o.id)}>عرض</button>
                        <button className="btn btn-sm btn-ghost btn-icon" title="فاتورة" onClick={() => printInvoice(o.id)}>🧾</button>
                        {isManager && o.remaining_amount > 0 && o.status !== 'cancelled' && (
                          <button className="btn btn-sm btn-success" onClick={() => setPayModal(o)}>دفعة</button>
                        )}
                        {user?.role === 'admin' && (
                          <button className="btn btn-sm btn-danger btn-icon" onClick={() => deleteOrder(o)}>🗑</button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {filtered.length === 0 && (
                <tr><td colSpan={9}>
                  <div className="empty-state">
                    <div className="empty-state-icon">🛒</div>
                    <p>{search || filterStatus ? 'لا توجد نتائج للبحث' : 'لا توجد طلبات بعد'}</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination page={page} total={filtered.length} perPage={PER_PAGE} onPage={setPage} />
      </div>
    </div>
  );
}
